export default __webpack_public_path__ + "static/media/icon-storage.5d169f6a.svg";